/**
 * Point de choix de la plateforme.
 *
 * C'est le SEUL fichier à modifier pour passer l'application en natif. Quand
 * la coque Capacitor sera en place, il suffira d'y détecter la plateforme et
 * de renvoyer les implémentations natives :
 *
 *   import { Capacitor } from '@capacitor/core';
 *   import { createNativePreferences } from './preferences.native';
 *   import { createNativeGeolocator } from './geolocation.native';
 *
 *   export const preferences = Capacitor.isNativePlatform()
 *     ? createNativePreferences()
 *     : createWebPreferences();
 *
 * Aucun autre fichier de l'application n'a besoin de savoir sur quoi il
 * tourne. C'est tout l'intérêt de faire passer le stockage et la
 * géolocalisation par une interface.
 */
import { createWebGeolocator, type Geolocator } from './geolocation';
import { createWebPreferences, type Preferences } from './preferences';

export const preferences: Preferences = createWebPreferences();
export const geolocator: Geolocator = createWebGeolocator();

export type { Geolocator, LocateFailure, LocateResult } from './geolocation';
export type { Preferences } from './preferences';
